module.exports = "mutation ($uuid: String!) {\n    userDelete(uuid: $uuid)\n}\n"